import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-327920ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  viewBox: "0 -5 320 225",
  width: "100%",
  id: "test-svg",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("linearGradient", {
    id: "grad1",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, [
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "0%",
      class: "color-stop",
      "stop-color": "hsla(0, 50%, 50%,0.6)"
    }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "100%",
      class: "color-stop",
      "stop-color": "hsla(0, 50%, 50%, 0.4)"
    })
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  height: "100%",
  width: "100%",
  fill: "hsl(0, 30%, 95%)"
}, null, -1))
const _hoisted_4 = ["y"]
const _hoisted_5 = {
  x: "10",
  y: "17",
  "font-size": "6px"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  class: "test-line",
  x1: "40",
  x2: "280",
  y1: "10",
  y2: "10",
  "vector-effect": "non-scaling-stroke",
  "stroke-width": "1",
  stroke: "hsla(0, 0%, 50%, 0.3)"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  class: "test-line",
  x1: "40",
  x2: "280",
  y1: "20",
  y2: "20",
  "vector-effect": "non-scaling-stroke",
  "stroke-width": "1",
  stroke: "hsla(0, 0%, 50%, 0.3)"
}, null, -1))
const _hoisted_8 = ["x1", "x2"]
const _hoisted_9 = ["d"]
const _hoisted_10 = ["x", "y", "width", "height"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["d", "onClick", "onMouseover"]
const _hoisted_13 = ["cx", "cy"]
const _hoisted_14 = ["x", "onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("polyline", {
  points: "15,30 0,30 7,25 7,5 7,0 8,0 8,5 8,25 15,30",
  "vector-effect": "non-scaling-stroke",
  class: "stroke-green"
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["x", "onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("polyline", {
  points: "8,30 7,30 7,25 7,5 0,0 15,0 8,5 8,25 8,30",
  "vector-effect": "non-scaling-stroke",
  class: "stroke-red"
}, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("text", {
  x: "290",
  y: "12",
  class: "text-medium",
  "font-size": "4px"
}, "Scharf", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("text", {
  x: "290",
  y: "22",
  class: "text-medium",
  "font-size": "4px"
}, "Unscharf", -1))
const _hoisted_22 = ["x"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTimes, (wd, wdIndex) => {
      return (_openBlock(), _createElementBlock("svg", {
        key: wdIndex,
        viewBox: "0 0 320 30",
        y: wdIndex*30,
        height: "30"
      }, [
        _createElementVNode("text", _hoisted_5, _toDisplayString(_ctx.weekdays[wdIndex]), 1),
        _hoisted_6,
        _hoisted_7,
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(25, (n, i) => {
          return _createElementVNode("line", {
            key: i,
            x1: i * 10 + 40,
            x2: i * 10 + 40,
            y1: "5",
            y2: "25",
            "stroke-width": "1",
            "vector-effect": "non-scaling-stroke",
            stroke: "hsla(0, 0%, 50%, 0.3)",
            class: "test-line"
          }, null, 8, _hoisted_8)
        }), 64)),
        _createElementVNode("path", {
          class: "interval-line",
          "stroke-width": "2",
          "vector-effect": "non-scaling-stroke",
          d: wd.stroke,
          stroke: "hsl(0, 50%, 50%)",
          fill: "hsl(0, 50%, 50%)",
          "fill-opacity": "0"
        }, null, 8, _hoisted_9),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wd.rects, (rect, sIndex) => {
          return (_openBlock(), _createElementBlock("rect", {
            key: sIndex,
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height,
            class: "test-block",
            fill: "url(#grad1)"
          }, null, 8, _hoisted_10))
        }), 128)),
        _createElementVNode("rect", {
          x: "40",
          y: "10",
          width: "240",
          height: "10",
          fill: "transparent",
          "data-hover": "",
          onClick: ($event: any) => (_ctx.addTime(wdIndex))
        }, null, 8, _hoisted_11),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wd.strokes, (stroke, sIndex) => {
          return (_openBlock(), _createElementBlock("path", {
            key: sIndex,
            class: "interval-block",
            "stroke-width": "2",
            "vector-effect": "non-scaling-stroke",
            d: stroke.stroke,
            onClick: _withModifiers(($event: any) => (_ctx.showInterval(stroke.interval)), ["stop"]),
            onMouseover: ($event: any) => (_ctx.showIntervalPreview(stroke, $event)),
            onMouseout: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.removeIntervalPreview && _ctx.removeIntervalPreview(...args))),
            "fill-opacity": "0",
            fill: "green"
          }, null, 40, _hoisted_12))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wd.circles, (circle, cIndex) => {
          return (_openBlock(), _createElementBlock("circle", {
            key: cIndex,
            cx: circle.cx,
            cy: circle.cy,
            r: "1",
            class: "test-circle",
            stroke: "hsl(0, 50%, 50%)",
            fill: "hsl(0, 50%, 50%)",
            "stroke-width": "1"
          }, null, 8, _hoisted_13))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wd.onPins, (on, onIndex) => {
          return (_openBlock(), _createElementBlock("svg", {
            viewBox: "0 0 15 30",
            key: onIndex,
            x: on.x - 3,
            y: "10",
            width: "6",
            height: "12",
            class: "on-pin",
            stroke: "hsl(150, 100%, 30%)",
            fill: "hsl(150, 100%, 30%)",
            onClick: ($event: any) => (_ctx.showOnTime(on))
          }, _hoisted_16, 8, _hoisted_14))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wd.offPins, (off, offIndex) => {
          return (_openBlock(), _createElementBlock("svg", {
            viewBox: "0 0 15 30",
            key: offIndex,
            x: off.x - 3,
            y: "8",
            width: "6",
            height: "12",
            class: "off-pin",
            stroke: "hsl(0, 100%, 30%)",
            fill: "hsl(0, 100%, 30%)",
            onClick: ($event: any) => (_ctx.showOffTime(off))
          }, _hoisted_19, 8, _hoisted_17))
        }), 128)),
        _hoisted_20,
        _hoisted_21
      ], 8, _hoisted_4))
    }), 128)),
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(25, (n, i) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
        (i%2===0)
          ? (_openBlock(), _createElementBlock("text", {
              key: 0,
              x: i * 10 + 38,
              y: "215",
              "stroke-width": "1",
              class: "test-line",
              "vector-effect": "non-scaling-stroke",
              "font-size": "6px",
              stroke: "hsla(0, 0%, 50%, 0.3)"
            }, _toDisplayString(i), 9, _hoisted_22))
          : _createCommentVNode("", true)
      ], 64))
    }), 64))
  ]))
}